import { useCallback, useMemo, useState } from 'react';
export const useConfirmModal = ({
  onConfirm
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const openConfirmModal = useCallback(() => {
    setIsOpen(true);
  }, []);
  const closeConfirmModal = useCallback(() => {
    setIsOpen(false);
  }, []);
  const handleConfirm = useCallback(() => {
    setIsOpen(false);
    onConfirm();
  }, [onConfirm]);
  const confirmModalProps = useMemo(() => ({
    onConfirm: handleConfirm,
    onReject: closeConfirmModal
  }), [handleConfirm, closeConfirmModal]);
  return {
    isOpen,
    openConfirmModal,
    confirmModalProps
  };
};